import { render, staticRenderFns } from "./plan-adjust.vue?vue&type=template&id=2fb8333e&scoped=true"
import script from "./plan-adjust.vue?vue&type=script&lang=js"
export * from "./plan-adjust.vue?vue&type=script&lang=js"
import style0 from "./plan-adjust.vue?vue&type=style&index=0&id=2fb8333e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb8333e",
  null
  
)

export default component.exports